import React from "react";
import { PropertyLocation } from "./PropertyLocation";
import { useQuery } from "react-query";
import { getPropertyLocationDetails } from "../../api/api";
import { useProperty } from "../../hooks/property.hooks";
import { PropertyDistances } from "./distances/PropertyDistances";
import { PropertyHazardousObjects } from "./hazardousObjects/PropertyHazardousObjects";
import { PropertySustainabilityReview } from "./PropertySustainabilityReview";
import { PropertyPenCertificate } from "./PropertyPenCertificate";

interface PropertyLocationReportProps {
  propertyId: string;
}

export const PropertyLocationReport: React.FC<PropertyLocationReportProps> = ({
  propertyId,
}) => {
  const { data: property, refetch: refetchProperty } = useProperty(propertyId);

  const { data: propertyLocation, refetch } = useQuery(
    ["property_location", propertyId],
    () => getPropertyLocationDetails(propertyId),
    {
      refetchInterval: (data) =>
        data?.some((location) => !location.generatingCompleted) ? 5000 : false,
    }
  );

  const refetchLocationAndProperty = () => {
    refetch();
    refetchProperty();
  };

  return (
    <div>
      {!!property && <PropertyDistances property={property} />}
      {!!property && <PropertyHazardousObjects property={property} />}
      {!!property && <PropertyPenCertificate property={property} />}
      {propertyLocation && (
        <>
          <PropertySustainabilityReview
            property={property}
            locations={propertyLocation}
            onRegenerate={refetchLocationAndProperty}
          />
          <PropertyLocation
            locations={propertyLocation}
            onRegenerate={refetchLocationAndProperty}
          />
        </>
      )}
    </div>
  );
};
